import { Page } from '@app/components/page/Page';
import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import { BreadcrumbItem } from '@mi-front/ui';
import compact from 'lodash/compact';
import { useIntl } from 'react-intl';

interface Props {
  platform?: SocialPlatform;
  items?: readonly BreadcrumbItem[];
}

export function SocialExportBreadcrumbs({ platform, items: extraItems = [] }: Props) {
  const { $t } = useIntl();

  const items = compact([
    ...(platform
      ? [
          {
            content: $t(
              {
                id: 'admin.socialExport.title',
                defaultMessage: 'Integración con {name}',
              },
              { name: platform.name },
            ),
            href: `/admin/social-export/${platform.id.toLowerCase()}`,
          },
        ]
      : []),
    ...extraItems,
  ]);

  if (items.length === 0) {
    return null;
  }

  return <Page.Breadcrumbs items={items} />;
}
